// export const BACKEND_IP = "greentestdelivery.localtunnel.me";
// export const BACKEND_IP = "http://localhost:8080";
// export const BACKEND_IP = "146.115.178.130:3001";
export const BACKEND_IP = "https://green-thumb-growers.uk.r.appspot.com";
